module.exports = __webpack_public_path__ + "img/svg/step2.9203d88269982617e6fbbae932c11f9e.svg";